module.exports = __webpack_public_path__ + "static/media/icon_clipboard-check.68e15723.svg";